/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import common from '../locales/es/common.json';
import location from '../locales/es/location.json';
import propertiesFeature from '../locales/es/features/properties.json';
import visits from '../locales/es/features/visits.json';
import members from '../locales/es/features/members.json';
import blog from '../locales/es/features/blog.json';
import popups from '../locales/es/features/popups.json';
import filters from '../locales/es/features/filters.json';
import pricing from '../locales/es/features/pricing.json';
import clients from '../locales/es/features/clients.json';
import cookieConsent from '../locales/es/features/cookie-consent.json';
import agencySettings from '../locales/es/features/agency-settings.json';
import agenda from '../locales/es/features/agenda.json';
import landing from '../locales/es/pages/landing.json';
import earlyAccess from '../locales/es/pages/early-access.json';
import notFound from '../locales/es/pages/not-found.json';
import error from '../locales/es/pages/error.json';
import agencies from '../locales/es/pages/agencies.json';
import propertiesPage from '../locales/es/pages/properties.json';
import manageAgencies from '../locales/es/pages/manage-agencies.json';
import manageProperties from '../locales/es/pages/manage-properties.json';
import registerAgency from '../locales/es/pages/register-agency.json';
import propertyPages from '../locales/es/pages/property-pages.json';
import layout from '../locales/es/pages/layout.json';
import policy from '../locales/es/pages/policy.json';
import onboarding from '../locales/es/pages/onboarding.json';
import welcome from '../locales/es/pages/welcome.json';
import userSettings from '../locales/es/pages/user-settings.json';
import publicProperty from '../locales/es/pages/public-property.json';
import dataRights from '../locales/es/pages/data-rights.json';
import visitsPage from '../locales/es/pages/visits.json';
import agencySiteConfig from '../locales/es/features/agency-site-config.json';
import deals from '../locales/es/features/deals.json';
import attendances from '../locales/es/features/attendances.json';
import leases from '../locales/es/features/leases.json';
import sales from '../locales/es/features/sales.json';
import vistories from '../locales/es/features/vistories.json';
import partnerships from '../locales/es/features/partnerships.json';
import launches from '../locales/es/features/launches.json';
import productTour from '../locales/es/features/product-tour.json';
import subscription from '../locales/es/features/subscription.json';
import spreadsheets from '../locales/es/features/spreadsheets.json';
import supportAccess from '../locales/es/features/support-access.json';
import assistant from '../locales/es/features/assistant.json';

/**
 * Spanish translation namespaces.
 */
export const es = {
  common,
  location,
  'features/properties': propertiesFeature,
  '@features/properties': propertiesFeature,
  'features/visits': visits,
  'features/members': members,
  'features/blog': blog,
  'features/popups': popups,
  'features/filters': filters,
  'features/pricing': pricing,
  'features/clients': clients,
  '@features/clients': clients,
  'features/cookie-consent': cookieConsent,
  'features/agency-settings': agencySettings,
  'features/agenda': agenda,
  '@pages/landing': landing,
  '@pages/early-access': earlyAccess,
  '@pages/not-found': notFound,
  '@pages/error': error,
  '@pages/agencies': agencies,
  '@pages/properties': propertiesPage,
  '@pages/manage-agencies': manageAgencies,
  '@pages/manage-properties': manageProperties,
  '@pages/register-agency': registerAgency,
  '@pages/property-pages': propertyPages,
  '@pages/layout': layout,
  '@pages/policy': policy,
  '@pages/onboarding': onboarding,
  '@pages/welcome': welcome,
  '@pages/user-settings': userSettings,
  '@pages/public-property': publicProperty,
  '@pages/data-rights': dataRights,
  '@pages/visits': visitsPage,
  'features/agency-site-config': agencySiteConfig,
  'features/deals': deals,
  'features/attendances': attendances,
  'features/leases': leases,
  'features/sales': sales,
  'features/vistories': vistories,
  'features/partnerships': partnerships,
  'features/launches': launches,
  'features/product-tour': productTour,
  'features/subscription': subscription,
  'features/spreadsheets': spreadsheets,
  'features/support-access': supportAccess,
  'features/assistant': assistant,
};
